export default __webpack_public_path__ + "static/media/cardspal_popup.10a07f16.png";